import { WillCountry } from '../../../../data/will-countries/will-countries';

export default {
    premium: {
        premiumWills: '綜合平安紙服務',
        premiumWills2: '綜合平安紙服務',
        heroEyebrow: '綜合平安紙服務',
        heading: '為複雜遺產規劃而設的綜合平安紙',
        heading2: '',
        subHeading: '與遺產規劃專員一對一規劃平安紙，為複雜家庭、業務、海外資產及跨境情況提供度身起草支援。',
        heroReassurance: '適合需要比標準網上平安紙更深入支援的人士。',
        primaryCta: '預約會面',
        explorePremiumWills: '了解綜合平安紙',
        premiumWillPriceHeading: '綜合平安紙',
        startPremiumWill: '開始綜合平安紙服務',
        secondaryCta: '查看價格',
        heroTrustSession: '私人規劃會面',
        heroTrustDrafting: '度身起草',
        heroTrustCrossBorder: '跨境指引',
        heroImageAlt: '遺產規劃專員為夫婦提供平安紙規劃指引',
        contactCta: '聯絡團隊',
        chatNow: '立即聯絡我們',
        chatInitialMessage: '我對綜合平安紙服務感興趣，並希望開始了解。',
        maxSupport: '最全面支援',
        productDescription: '最適合面對複雜、敏感或跨境情況，並希望獲得一對一指引及度身起草的人士。',
        productSub: '夫妻組合價格 {{price}}',
        forAdditionalCountries: '適用於其他國家',
        includes1: '度身訂造平安紙',
        includes2: '按需要任命監護人',
        includes3: '給遺囑執行人的信函',
        includes4: '意願書',
        includes5: '資產和數碼資產清單',
        includes6: '私人遺產規劃會面',
        includes7: '所有文件的專業打印',
        includes10: '在平安紙簽署前可無限次修改內容',
        includes8: '簽署及見證支援',
        includes9: '臨時監護權契約',
        optionalAddonsHeading: '可選下一步',
        storageEditingSubscription: '保管及修改訂閱',
        whoEyebrow: '適合對象',
        whoHeading: '綜合平安紙適合哪些人士',
        whoIntro: '綜合平安紙適合家庭、資產或意願需要比標準網上流程更深入討論的人士。',
        for_parents_heading: '有年幼子女的父母',
        for_parents_body: '任命監護人，並清楚記錄對家人的實際安排和意願。',
        for_overseasAssets_heading: '有海外資產或物業',
        for_overseasAssets_body: '處理多個國家的物業、戶口、投資或受益人安排。',
        for_businessOwners_heading: '企業主或股東',
        for_businessOwners_body: '考慮公司權益、承繼安排，以及相關資產應如何處理。',
        for_blendedFamilies_heading: '重組家庭',
        for_blendedFamilies_body: '在家庭安排需要更仔細說明時，清楚表達您的意願。',
        for_specificWishes_heading: '特定禮物或條件',
        for_specificWishes_body: '以更有彈性的方式記錄個人意願、禮物、慈善安排和指示。',
        for_highValueEstates_heading: '高價值或較複雜資產',
        for_highValueEstates_body: '在需要清晰、協調及仔細起草時，獲得更有指引的流程。',
        for_guidedExperience_heading: '想要更多個人指引',
        for_guidedExperience_body: '在簽署重要文件前，先與真人團隊討論您的情況。',
        premiumDifferenceEyebrow: '綜合服務的不同之處',
        premiumDifferenceHeading: '個人指引、周詳規劃及專業準備的文件',
        premiumDifferenceBody: '選用綜合平安紙服務，您不需要獨自處理每一個決定。我們會了解您的家庭、資產、遺囑執行人、監護人、受益人和意願，並準備能清楚反映您情況的文件。',
        feature_privateConsultation_heading: '私人遺產規劃會面',
        feature_privateConsultation_body: '集中了解您的情況、優先事項和關注。',
        feature_planningReview_heading: '遺產規劃檢視',
        feature_planningReview_body: '實際討論遺囑執行人、監護人、禮物、受益人和分配意願。',
        feature_crossBorderSupport_heading: '跨境考慮',
        feature_crossBorderSupport_body: '協助識別國際資產或家庭情況中可能需要額外留意的地方，例如遺產稅或強制繼承規則。',
        adviceBoundary: 'NobleWills 不提供稅務、投資或財務建議。我們可協助識別海外資產或家庭情況所引起的問題，但你可能需要向每個相關司法管轄區具備適當資格的顧問尋求獨立意見。',
        feature_customDrafting_heading: '度身起草',
        feature_customDrafting_body: '為未必適合標準網上問卷流程的情況提供起草支援。',
        feature_signingGuidance_heading: '簽署及存放指引',
        feature_signingGuidance_body: '就簽署、見證、存放及日後更新提供清晰下一步。',
        pricingEyebrow: '價格',
        pricingHeading: '由規劃到完成，全程提供個人支援',
        pricingBody: '綜合平安紙服務的價格包括私人遺產規劃會面、度身起草及完成文件前的實務支援。',
        comparisonHeading: '不同情況需要不同程度的支援',
        comparisonIntro: '網上平安紙適合較直接的意願。綜合服務則適合希望在簽署前獲得更多指引、彈性及信心的客戶。',
        onlineComparisonLabel: '自行完成',
        premiumComparisonLabel: '團隊指引',
        onlineComparisonHeading: '網上平安紙',
        onlineComparisonBody: '適合意願較直接、家庭安排較標準，並希望透過網上平台自行完成流程的客戶。',
        premiumComparisonHeading: '綜合平安紙',
        premiumComparisonBody: '適合情況較複雜、敏感、具國際背景，或希望透過私人諮詢及度身起草獲得更多支援的客戶。',
        comparison_bestFor_label: '最適合',
        onlineComparison_bestFor: '較直接的意願及標準家庭安排。',
        premiumComparison_bestFor: '複雜家庭、海外資產、業務權益或特定意願。',
        comparison_process_label: '流程',
        onlineComparison_process: '按照網上指引自行完成。',
        premiumComparison_process: '由私人諮詢開始，並獲得度身起草支援。',
        comparison_support_label: '支援',
        onlineComparison_support: '平台指引及按需要提供團隊支援。',
        premiumComparison_support: '由遺產規劃團隊在整個流程中提供一對一私人支援。',
        comparison_complexity_label: '複雜程度',
        onlineComparison_complexity: '適合意願能配合標準網上結構的情況。',
        premiumComparison_complexity: '適合可能需要更多彈性或檢視的情況。',
        whatYouGetHeading: '服務內容',
        whatYouGetIntro: '一項圍繞您的家庭、資產和希望清楚記錄的決定而設的諮詢式服務。',
        included_consultation_heading: '私人遺產規劃會面',
        included_consultation_body: '透過視像會議與 NobleWills 遺產規劃專員討論您的情況和意願。',
        included_consultation_bodyWithWitnessing: '親身或透過視像會議與 NobleWills 遺產規劃專員討論您的情況和意願。',
        included_familyReview_heading: '家庭及資產檢視',
        included_familyReview_body: '在起草前檢視家庭、資產、受益人及跨境情況。',
        included_executorPlanning_heading: '執行人及監護人安排',
        included_executorPlanning_body: '釐清遺囑執行人、監護人、受益人、禮物和實際指示。',
        included_customWill_heading: '度身訂造平安紙',
        included_customWill_body: '按照您的指示準備度身訂造的平安紙，並在完成前供您查閱。',
        included_letterOfWishes_heading: '輔助文件',
        included_letterOfWishes_body: '按需要準備意願書、資產清單等輔助文件。',
        included_crossBorderReview_heading: '跨境檢視',
        included_crossBorderReview_body: '識別可能影響遺產安排結構的國際因素。',
        included_signingStorageGuidance_heading: '簽署及存放指引',
        included_signingStorageGuidance_body: '提供簽署、見證、存放及日後更新的清晰指引。',
        included_witnessing_heading: '簽署及見證支援',
        included_witnessing_body: '在提供此服務的地區，安排簽署及見證支援。',
        included_temporaryGuardianship_heading: '臨時監護權契約',
        included_temporaryGuardianship_body: '在提供此服務的地區，準備臨時監護權契約。',
        commonSituationsHeading: '我們常協助處理的情況',
        commonSituationsIntro: '如果以下任何一項與您相似，綜合服務可能比標準網上流程更合適。',
        situation_children: '我有子女，並希望任命監護人。',
        situation_multiCountryProperty: '我在多於一個國家擁有物業或資產。',
        situation_differentExecutors: '我想由不同人士管理不同部分的遺產。',
        situation_businessShares: '我有業務、公司股份或合夥權益。',
        situation_familySituation: '我的家庭情況並非完全簡單直接。',
        situation_clearWishes: '我希望清楚記錄自己的意願。',
        descriptionHeading: '綜合平安紙團隊可能支援的司法管轄區',
        description: '服務是否適用須按個別情況確認。一份平安紙不會自動涵蓋所有司法管轄區，你可能需要指定國家或地區的文件，或尋求獨立的當地專業意見。',
        description2: '',
        description3: '我們可以為以下司法管轄區撰寫平安紙：',
        description4: '此列表並非完整，亦不代表保證提供服務。請聯絡我們，以確認團隊是否可能就每個相關司法管轄區提供協助。綜合平安紙目前以英語準備。',
        reviewProvenance: '服務資料已由 NobleWills 遺產規劃團隊檢視。最後檢視日期：{{date}}。',
        meetOurTeam: '認識我們的團隊。',
        how: '綜合平安紙服務流程',
        initial: '了解你的情況',
        initialBody: '我們會先了解你的家庭、資產、意願及涉及的司法管轄區，確認綜合平安紙服務適合你的情況，並與你確定服務範圍。',
        meeting: '與遺產規劃專員會面',
        meetingBody: '你可以透過視像會議與 NobleWills 的遺產規劃專員私下會面；在設有服務的地區，亦可安排親身會面，商討你的指示及遺產規劃重點。',
        drafting: '草擬平安紙',
        draftingBody: '我們會按照你的指示，在已確定的服務範圍內，為你度身草擬平安紙及相關文件。',
        finalize: '審閱及修改',
        finalizeBody: '你可以審閱草稿、提出問題及要求修改。在文件簽署前，修改次數不限。',
        sign: '簽署及完成',
        signBody: '我們會提供清晰的簽署及見證指引；在香港，我們會為你安排簽署及見證。文件保管及日後修改服務亦可按你的需要加購。',
        finalCtaHeading: '準備好討論您的遺產計劃？',
        finalCtaBody: '預約私人諮詢，我們的團隊會協助您了解綜合服務是否適合您的家庭、資產和意願。',
        [WillCountry.unitedKingdom]: '英國',
        [WillCountry.australia]: '澳洲',
        [WillCountry.unitedStates]: '美國',
        [WillCountry.singapore]: '新加坡',
        [WillCountry.malaysia]: '馬來西亞',
        [WillCountry.india]: '印度',
        [WillCountry.caymanIslands]: '開曼群島',
        [WillCountry.jersey]: '澤西島',
        [WillCountry.guernsey]: '根西島',
        [WillCountry.isleOfMan]: '曼島',
        [WillCountry.thailand]: '泰國',
        [WillCountry.vietnam]: '越南',
        [WillCountry.philippines]: '菲律賓',
        // [WillCountry.mainlandChina]: 'Mainland China',
        [WillCountry.japan]: '日本',
        [WillCountry.hongKong]: '香港',
        [WillCountry.canada]: '加拿大',
        [WillCountry.newZealand]: '新西蘭',
        [WillCountry.taiwan]: '台灣',
        [WillCountry.britishVirginIslands]: '英屬維京群島',
        [WillCountry.france]: '法國',
        [WillCountry.germany]: '德國',
        [WillCountry.italy]: '意大利',
        [WillCountry.gibraltar]: '直布羅陀',
        [WillCountry.luxembourg]: '盧森堡',
        [WillCountry.ireland]: '愛爾蘭',
        [WillCountry.israel]: '以色列',
        // [WillCountry.sweden]: '瑞典',
        [WillCountry.switzerland]: '瑞士',
        [WillCountry.southAfrica]: '南非',
    },
};
